__turbopack_context__.v({
  "fadeInItems": "Polaroids-module__bpihwa__fadeInItems",
  "image": "Polaroids-module__bpihwa__image",
  "imageRatio": "Polaroids-module__bpihwa__imageRatio",
  "imageResized": "Polaroids-module__bpihwa__imageResized",
  "imageWrapper": "Polaroids-module__bpihwa__imageWrapper",
  "imageWrapperLandscape": "Polaroids-module__bpihwa__imageWrapperLandscape",
  "row": "Polaroids-module__bpihwa__row",
  "spacing--lg": "Polaroids-module__bpihwa__spacing--lg",
  "spacing--md": "Polaroids-module__bpihwa__spacing--md",
  "spacing--sm": "Polaroids-module__bpihwa__spacing--sm",
  "spacing--xl": "Polaroids-module__bpihwa__spacing--xl",
  "spacing--xs": "Polaroids-module__bpihwa__spacing--xs",
  "spacing--xxl": "Polaroids-module__bpihwa__spacing--xxl",
  "spacing--xxs": "Polaroids-module__bpihwa__spacing--xxs",
  "spacing--xxxl": "Polaroids-module__bpihwa__spacing--xxxl",
  "spacing--xxxs": "Polaroids-module__bpihwa__spacing--xxxs",
});
